<template>
  <div
    data-test="appeal-point-div"
    class="appeal-points"
    :class="[isSearchResult? 'fll':'mt20']"
  >
    <p class="fll h-style-02">
      アピールポイント
    </p>
    <p class="flr link-type-01">
      <a
        target="_blank"
        :style="`cursor: pointer; background: url(${userCommonImageUrlForPc}/icn_arrow_01.png) no-repeat left;`"
        data-test="help"
        @click="openHelpPopUp('icon.html')"
      >
        アイコンの説明
      </a>
    </p>
    <div class="clearfix" />
    <ul class="appeal-point">
      <li
        v-for="prIcon in prIconsMaster"
        :id="targetIdMap.mainArticle.pr[prIcon.id]"
        :key="prIcon.id"
        :class="{'on':isSetPr(prIcon.id)}"
        :data-test="`pr-${prIcon.id}`"
        v-text="prIcon.name"
      />
    </ul>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/search/base" as *;
</style>

<script>
import { mapGetters, mapActions } from 'vuex'
import jobPreviewCommon from '@/lib/jobPreviewCommon'

export default {
  mixins: [jobPreviewCommon],
  props: {
    isSearchResult: {
      type: Boolean,
      default: false
    },
    prCodes: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters([
      'prIconsMaster'
    ])
  },
  created () {
    this.storeMaster('prIcons')
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ])
  }
}
</script>
